import { getSharingTipInfo } from './getSharingTipInfo';
import { SharingData } from '../schema/SharingData';
import { getSharingTipIdsList, SharingTipId } from '../types/sharingTipId';
import { SharingTipInfo } from '../types/SharingTipInfo';
import { SharingTipRecipientInfo } from '../types/SharingTipRecipientInfo';
import { logSharingTipChangesForLink } from './logSharingTipChangesForLink';

export function getSharingIssuesForSharingData(
    sharingData: SharingData,
    recipientInfo: SharingTipRecipientInfo[]
): SharingTipInfo[] {
    const sharingTipIds: SharingTipId[] = getSharingTipIdsList();

    const sharingTipInfo: SharingTipInfo[] = sharingTipIds
        .filter(id => sharingData.sharingTipsIgnored.indexOf(id) === -1)
        .map(sharingTipId => {
            return getSharingTipInfo(
                [sharingData],
                sharingTipId,
                recipientInfo,
                true /* skipActionRecommendation */
            );
        })
        .filter(x => x !== null);

    // This indicates that the sharing data came from a link.
    // TODO - should we add a type property to link?
    if (typeof sharingData.id === 'string') {
        const idsOfSharingIssues: SharingTipId[] = sharingTipInfo.map(info => info.id);
        logSharingTipChangesForLink(
            <string>sharingData.id,
            idsOfSharingIssues,
            sharingData.typeOfLink
        );
    }
    return sharingTipInfo;
}
